module.exports = __webpack_public_path__ + "img/worldGood.1cb18f83.svg";